import qs from 'qs';
import { Config } from 'store/config/enums';
import { getDefaultApiUrl } from 'store/config/get-default-url.util';
import { extractBuildingUuidFromPath } from 'utils/formatPath';
import { ConfigState } from './types';

// Exported so user store can also initialize with the same token
export const getInitialAuthToken = (): string | null => {
  const queryParams = qs.parse(window.location.search?.replace(/^\?/, '')) as unknown as ConfigState;
  return queryParams.authToken ?? localStorage.getItem(Config.AUTH_TOKEN_LS_KEY) ?? null;
};

export function getInitialState(): ConfigState {
  const queryParams = qs.parse(window.location.search?.replace(/^\?/, '')) as unknown as ConfigState;
  const pathBuildingUuid = extractBuildingUuidFromPath(window.location.pathname);

  // Service building UUID - from path (where the service is located)
  // Falls back to localStorage for returning users, then query param for same-building bookings
  const buildingUuid =
    pathBuildingUuid ?? localStorage.getItem(Config.BUILDING_UUID_LS_KEY) ?? queryParams.buildingUuid ?? null;

  // User building UUID - from query param buildingUuid (user's home building for theme/auth)
  // Falls back to localStorage, then buildingUuid for same-building bookings
  const userBuildingUuid =
    queryParams.buildingUuid ?? localStorage.getItem(Config.USER_BUILDING_UUID_LS_KEY) ?? buildingUuid;

  // Query params take priority over localStorage
  // localStorage is updated by the reducer when saveExternalConfig is dispatched
  return {
    apiUrl: queryParams.apiUrl ?? localStorage.getItem(Config.API_URL_LS_KEY) ?? getDefaultApiUrl(),
    appBrand: queryParams.appBrand ?? localStorage.getItem(Config.APP_BRAND_LS_KEY) ?? null,
    buildingUuid,
    userBuildingUuid,
    locale: queryParams.locale ?? localStorage.getItem(Config.LOCALE_LS_KEY) ?? null,
    authToken: getInitialAuthToken(),
  };
}

export const initialState: ConfigState = getInitialState();
